import { combineReducers } from '@reduxjs/toolkit';

import { authApi } from '../api/auth';
import { configurationsApi } from '../api/configurations';
import actuatorsReducer from './actuatorsRedurer';
import appliancesReducer from './applianceReducer';
import appReducer from './appReducer';
import authReducer from './authReducer';
import controllersReducer from './controllersReducer';
import detectorsReducer from './detectorsReducer';
import newDeviceReducer from './newDeviceReducer';
import settingsReducer from './settingsReducer';
import userSettingsReducer from './userSettingsReducer';

export const rootReducer = combineReducers({
    app: appReducer,
    auth: authReducer,
    userSettings: userSettingsReducer,
    settings: settingsReducer,
    newDevice: newDeviceReducer,
    controllers: controllersReducer,
    actuators: actuatorsReducer,
    detectors: detectorsReducer,
    appliances: appliancesReducer,
    [authApi.reducerPath]: authApi.reducer,
    [configurationsApi.reducerPath]: configurationsApi.reducer
})

export default rootReducer;